import { render, staticRenderFns } from "./IntlStatusCheck.vue?vue&type=template&id=6579ccdc&scoped=true&"
import script from "./IntlStatusCheck.vue?vue&type=script&lang=js&"
export * from "./IntlStatusCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6579ccdc",
  null
  
)

export default component.exports